module.exports = __webpack_public_path__ + "static/media/profile.8e02c73d.jpg";